import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders dialog content into `document.body` rather than inside the app
 * root.
 *
 * This is what makes it possible to hide the rest of the page from
 * assistive technology: `aria-hidden` goes on `#root`, and a dialog nested
 * inside `#root` would be hidden along with it.
 */
export function DialogPortal({
  children
}: {
  children: React.ReactNode;
}) {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  useEffect(() => {
    const node = document.createElement('div');
    node.setAttribute('data-dialog-root', '');
    document.body.appendChild(node);
    setContainer(node);
    return () => {
      document.body.removeChild(node);
    };
  }, []);
  if (!container) return null;
  return createPortal(children, container);
}